import React, { useState } from 'react'
import { FloorMapSpaces } from '@api'
import { Flex } from '@ui'
import ChartSection from 'components/ChartSection'
import { groupBy, keys } from 'lodash'
import { Button } from '@runeffective/evo-design-system'
import typescriptNaturalSort from 'typescript-natural-sort'
import { getColor } from 'components/Reports/config'
import { NEIGHBORHOOD } from '@utils'
import UnseatAllPopup from './unseatAllPopup'

const formatData = (spaces: any, selectedItems: string[]) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )

  const filtered = items.filter((i: any) => i.spaceType.interactivityType === 2)

  const grouped = groupBy(filtered, ({ spaceAssignment, usageType }) =>
    spaceAssignment.employee ||
    spaceAssignment?.sharedEmployees?.length ||
    usageType?.name === NEIGHBORHOOD
      ? 'Occupied'
      : 'Unoccupied'
  )

  if (!grouped.Occupied) {
    return null
  }

  return keys(grouped)
    .sort((k1, k2) => typescriptNaturalSort(k1, k2))
    .map((key, i) => ({
      key,
      label: key,
      color: `#${getColor(i)}`,
      value: grouped[key].length,
      employeeCount: grouped[key].reduce((total, space) => {
        if (space.spaceAssignment.employee) return total + 1
        if (space.spaceAssignment.sharedEmployees)
          return space.spaceAssignment.sharedEmployees.length + total
        return total
      }, 0),
      percent: Math.round((grouped[key].length / filtered.length) * 100),
    }))
}

const OccupancySection = ({
  spaces,
  selectedItems,
  allEmployeesList,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
  allEmployeesList: string[]
}) => {
  const chartData = formatData(spaces, selectedItems)
  const [unseatAllPopupOpen, setunseatAllPopupOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="donut" colName="" description="" data={chartData} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        <Button
          layout="secondary"
          onClick={() => {
            setunseatAllPopupOpen(true)
          }}
          size="small"
        >
          Unseat all
        </Button>
      </Flex>
      <UnseatAllPopup
        setunseatAllPopupOpen={setunseatAllPopupOpen}
        unseatAllPopupOpen={unseatAllPopupOpen}
        selectedSpaces={selectedItems}
        allEmployeesList={allEmployeesList}
      />
    </div>
  )
}

export default OccupancySection
